import { render } from "./Portfolio-component.vue?vue&type=template&id=6db81d97&scoped=true"
import script from "./Portfolio-component.vue?vue&type=script&lang=js"
export * from "./Portfolio-component.vue?vue&type=script&lang=js"

import "./Portfolio-component.vue?vue&type=style&index=0&id=6db81d97&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db81d97"]])

export default __exports__